// Vidéos des fiches produit (19/10) : snippets/product-thumbnail.liquid rend chaque vidéo de la galerie en <video class="mf-pvid">
// muette, en boucle, sans commandes. Elle ne joue que si sa diapo est visible (galerie qui défile au doigt, diapo masquée sur
// ordinateur, page qui défile), et repart d'elle-même si le thème l'a mise en pause (window.pauseAllMedia de Dawn au changement
// de photo). Les balises sont relues à chaque passage : la galerie est reconstruite quand on change de couleur.
// « Réduire les animations » (réglage du téléphone) : pas de lecture, l'image d'aperçu reste.
// Indépendant de mf-video.js (vidéos de l'atelier, autre session).
(function () {
  if (window.mfProduitVideo) return;
  window.mfProduitVideo = true;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  function visible(v) {
    var r = v.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    // au moins un tiers de la vidéo à l'écran (une diapo voisine qui dépasse à peine ne joue pas)
    var w = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
    var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    return w > r.width / 3 && h > r.height / 3;
  }
  function sync() {
    var vids = document.querySelectorAll('video.mf-pvid');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (!still.matches && !document.hidden && visible(v)) {
        if (v.paused) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else if (!v.paused) {
        v.pause();
      }
    }
  }
  var t = 0;
  function soon() {
    if (t) return;
    t = setTimeout(function () {
      t = 0;
      sync();
    }, 100);
  }
  // capture : attrape aussi le défilement horizontal de la galerie sur téléphone
  window.addEventListener('scroll', soon, { passive: true, capture: true });
  window.addEventListener('resize', soon);
  document.addEventListener('visibilitychange', sync);
  // changement de photo (clic sur une vignette, flèches) et galerie reconstruite : pas d'événement de défilement
  document.addEventListener('click', function () { setTimeout(sync, 350); }, true);
  setInterval(sync, 1000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
